import FoyerMobile from "/components/shared/foyerMobile";
import { useEffect, useState } from "react";
import FoyerDesktop from "/components/shared/foyerDesktop";
import { fetchProductions } from "/api/productions";
import useMobileDetect from "use-mobile-detect-hook";

export default function Foyer() {
  const [view, setView] = useState(<FoyerDesktop />);
  const { isMobile } = useMobileDetect();

  useEffect(() => {
    if (isMobile()) {
      setView(<FoyerMobile />);
    } else setView(<FoyerDesktop />);
  }, []);

  return (
    <>
      <main>{view}</main>
    </>
  );
}

export async function getStaticProps(context) {
  const productions = await fetchProductions();
  return {
    props: {
      productions,
    },
    revalidate: 60,
  };
}
